import { endpoints } from '../../../api/domains/endpoints';
import api from '../../../api';


export async function initOauthSessionAPI ({  apiKey, body, traceId, store}) {
    let url = endpoints().oauthSession;
    return await api.post(
        `${url}?apiKey=${apiKey}&traceId=${traceId}`,
        body, /* body */
        { traceId }, /* options */
        store,
    );  
}

export async function oauthSessionAPI ({ sessionId, apiKey, body, traceId, store}) {
    let url = endpoints().oauthSession;
    return await api.get(
        `${url}/${sessionId}?apiKey=${apiKey}&traceId=${traceId}`,
        body, /* body */
        { traceId }, /* options */
        store,
    );  
}

export async function subscriberStatusAPI ({  apiKey, traceId, subscriberId, store}) {
    let url = endpoints().subscriberStatus;
    url = url.replace('{%id}', subscriberId);
    return await api.get(
        `${url}?apiKey=${apiKey}&traceId=${traceId}`,
        {}, /* body */
        {traceId }, /* options */
        store,
    );  
}
 
export async function completeSubscriptionAPI ({  apiKey, body, traceId, store}) {
    let url = endpoints().completeSubscription;
    return await api.put(
        `${url}?apiKey=${apiKey}&traceId=${traceId}`,
        body, /* body */
        { traceId }, /* options */
        store,
    );  
}

export async function subscriberAPI ({  apiKey, body, traceId, store}) {
    let url = endpoints().subscriber;
    return await api.post(
        `${url}?apiKey=${apiKey}&traceId=${traceId}`,
        body, /* body */
        { traceId }, /* options */
        store,
    );  
}

export async function subscribeWithIDAPI ({ subscriberId, apiKey, body, traceId, store}) {
    let url = endpoints().subscriber;
    return await api.put(
        `${url}/${subscriberId}?apiKey=${apiKey}&traceId=${traceId}`,
        body, /* body */
        { traceId }, /* options */
        store,
    );  
}

export async function subscriberActiveAPI ({  apiKey, body, traceId, store}) {
    const {
        appType,
        oauthSessionId,
        email,
    } = body;

    let url = endpoints().subscriberActive;
    return await api.get(
        `${url}?apiKey=${apiKey}&email=${email}&appType=${appType}&oauthSessionId=${oauthSessionId}&traceId=${traceId}`,
        {}, /* body */
        { traceId }, /* options */
        store,
    );  
}
